<template>
  <div class="main">
    <h3 style="text-align:center;">健帆-内部拼车 sop</h3>
    <h4>拼车原则：</h4>
    <div>1、 健帆拼车仅限内部员工使用；</div>
    <div>2、 拼车仅限车主发布行程，乘客根据路线搭乘相匹配的车辆；</div>
    <div>3、 车主发布行程后，有乘客搭乘的情况下行程不可取消；</div>
    <div>4、 车主点击确认发车代表本次拼车完成；</div>
    <div>5、 每日仅限一次行程：发布/搭乘后不可更换身份再次拼车；</div>
    <div>6、 车主的行程路线默认上一次提交的信息，可在“我的-路线设置”更改。</div>
    <h4>1. 进入“健帆生物股份”企业微信，选择“内部拼车”</h4>
    <div style="text-align:center;">
      <van-image width="70%" :src="require('../../assets/guide/img1.png')" />
      <br><br>
      <van-image width="70%" :src="require('../../assets/guide/img2.jpg')" />
    </div>
    <h4>2. 点击“拼车平台”注册认证“乘客/司机”---乘客: 身份信息关联企业微信（手机号码可更改）</h4>
    <div style="text-align:center;">
      <div>1.提交认证</div>
      <van-image width="70%" :src="require('../../assets/guide/img3.jpg')" />
      <div>2.选择相应路线、行程</div>
      <van-image width="70%" :src="require('../../assets/guide/img4.jpg')" />
      <div>3.确认拼车</div>
      <van-image width="70%" :src="require('../../assets/guide/img5.jpg')" />
      <div>4.确认拼车成功、有问题及时联系司机</div>
      <van-image width="70%" :src="require('../../assets/guide/img6.jpg')" />
    </div>
    <h4>3. 注册认证“乘客/司机”---司机: 身份信息关联企业微信（手机号码可更改）</h4>
    <div style="text-align:center;">
      <div>1.车辆信息认证：据实填报</div>
      <van-image width="70%" :src="require('../../assets/guide/img7.jpg')" />
      <div>2.路线设置：选择对应路线、填写目的地</div>
      <van-image width="70%" :src="require('../../assets/guide/img9.jpg')" />
      <van-image width="70%" :src="require('../../assets/guide/img10.jpg')" />
      <div>3.填写其他路线信息—发布拼车</div>
      <van-image width="70%" :src="require('../../assets/guide/img11.jpg')" />
      <div>4.确认拼车人员后确认发车，本次拼车结束</div>
      <van-image width="70%" :src="require('../../assets/guide/img12.jpg')" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>

<style lang="less" scoped>
  .main {
    background-color: #ffffff;
    padding: 12px;
    font-size: 14px;
  }
</style>